<template lang="pug">
.login-page-container
  .fail-block-img
    img(src="https://m.hellobike.com/resource/helloyun/08345/UtlXJiq5RV.png?x-oss-process=image/quality,q_80")
  .fail-big-word 您还没有登录
  .fail-samll-word 请登录后查看福利信息
  .fail-btn(@click="goLogin") 登录
</template>

<script>
import { Native } from '@hb/NBridge/lib/h5';

export default {
  name: 'LoginPage',
  components: {},
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goLogin() {
      Native.closeWebView();
    },
  },
};
</script>

<style lang="less" scoped>
.login-page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background-color: #fff;

  .fail-block-img {
    margin-top: 25vh;

    img {
      width: 1.6rem;
      height: 1.5rem;
    }
  }

  .fail-big-word {
    margin-top: 0.12rem;
    font-size: 0.16rem;
    line-height: 0.22rem;
    color: #242729;
  }

  .fail-samll-word {
    font-size: 0.14rem;
    font-weight: 400;
    line-height: 0.2rem;
    color: #879099;
    margin-top: 0.04rem;
  }

  .fail-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.2rem;
    width: 1rem;
    height: 0.4rem;
    background: #08f;
    color: #fff;
    font-size: 0.16rem;
    font-weight: 500;
    border-radius: 0.04rem;
    line-height: normal;
  }
}
</style>
